export default function TabLinkIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5C4 4.44772 4.44771 4 5 4H15C15.5523 4 16 4.44772 16 5V15C16 15.5523 15.5523 16 15 16H8.24264L10.2426 14H14V6H6V9.75736L4 11.7574V5ZM8.08559 7.99976L10.5001 7.99995L11 7.99999L11.9996 8.00007L11.9999 8.99974L12 9.4997L12.0006 11.9148L10.75 10.6641L4.4142 17H3V15.5858L9.33575 9.24992L8.08559 7.99976Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
